import * as React from "react";

const LinkIcon = ({
  width = 24,
  height = 24,
  title = "Link",
  ...rest
}: IconProps) => (
  <svg
    data-testid="link-icon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...rest}>
    <title>{title}</title>
    <path
      stroke="#46494B"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 4H4v16h16v-6"
    />
    <path
      fill="#46494B"
      d="M11.646 11.646a.5.5 0 0 0 .708.708L12 12l-.354-.354ZM20.5 4a.5.5 0 0 0-.5-.5h-4.5a.5.5 0 0 0 0 1h4v4a.5.5 0 0 0 1 0V4ZM12 12l.354.354 8-8L20 4l-.354-.354-8 8L12 12Z"
    />
  </svg>
);
export default LinkIcon;
